/* ==========================================================================
   Help Centre (sections/eu-help-centre.liquid)

   The picker and the "Read the full detail" buttons open one service's detail
   panel at a time and bring it into view. Videos swap their thumbnail for the
   YouTube player only when pressed.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.getElementById('HelpCentre');
  if (!root) return;

  var all = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  function open(key, scrollTo) {
    all('[data-hc-detail]').forEach(function (p) {
      p.hidden = p.getAttribute('data-hc-detail') !== key;
    });
    all('[data-hc-toggle]').forEach(function (b) {
      var on = b.getAttribute('data-hc-toggle') === key;
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      b.textContent = on ? 'Hide the detail' : 'Read the full detail';
    });
    all('[data-hc-card]').forEach(function (c) {
      c.classList.toggle('is-picked', c.getAttribute('data-hc-card') === key);
    });
    all('[data-hc-pick]').forEach(function (p) {
      p.classList.toggle('is-picked', p.getAttribute('data-hc-pick') === key);
    });
    var target = scrollTo && root.querySelector(scrollTo);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function close() {
    all('[data-hc-detail]').forEach(function (p) { p.hidden = true; });
    all('[data-hc-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      b.textContent = 'Read the full detail';
    });
  }

  all('[data-hc-pick]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var key = a.getAttribute('data-hc-pick');
      open(key, '#hc-' + key);
      history.replaceState(null, '', '#hc-' + key);
    });
  });

  all('[data-hc-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-hc-toggle');
      if (b.getAttribute('aria-expanded') === 'true') close();
      else open(key, '#hc-detail-' + key);
    });
  });

  all('[data-hc-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.getAttribute('data-hc-close');
      close();
      var card = root.querySelector('#hc-' + key);
      if (card) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* A link straight to a service (/pages/help#hc-dtf) opens its detail. */
  var hash = location.hash.replace('#hc-', '');
  if (hash && root.querySelector('[data-hc-detail="' + hash + '"]')) open(hash, null);

  all('[data-hc-video]').forEach(function (v) {
    var btn = v.querySelector('button');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = v.getAttribute('data-hc-video');
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      frame.title = btn.getAttribute('aria-label') || 'Video';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      v.textContent = '';
      v.appendChild(frame);
    });
  });
})();
